import { createStore, applyMiddleware, combineReducers } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createBrowserHistory, History } from 'history'
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk'

// Reducers
import ab from 'modules/ab'
import artists from 'modules/artists'
import audio from 'modules/audio'
import auth from 'modules/auth'
import browse from 'modules/browse'
import collections from 'modules/collections'
import entities from 'modules/entities'
import featureToggles from 'modules/featuretoggles'
import labels from 'modules/labels'
import header from 'modules/header'
import notifications from 'modules/notifications'
import pay from 'modules/pay'
import requests from 'modules/requests'
import signup from 'modules/signup'
import staticPages from 'modules/staticpages'
import subscription from 'modules/subscription'

// Types
import type { State, EntitiesState } from 'types'

// Utils
import apiMiddleware from 'middleware'
import trackingMiddleWare from 'tracking_middleware'
import { isBrowser } from '@process'
import { createInitialState } from 'initialstate'

export const history: History<unknown> = isBrowser && createBrowserHistory()

export const createStoreWithMiddleware = applyMiddleware(
  apiMiddleware,
  trackingMiddleWare,
  thunkMiddleware as ThunkMiddleware<State>,
  routerMiddleware(history),
)(createStore)

const reducer = combineReducers({
  ab,
  artistsSearch: artists,
  audio,
  auth,
  browse,
  collectionsSearch: collections,
  entities,
  featureToggles,
  header,
  labelsSearch: labels,
  notifications,
  pay,
  requests,
  router: connectRouter(history),
  signup,
  staticPages,
  subscription,
})

export const initStoreWithFinalState = (finalState: Partial<State>) =>
  createStoreWithMiddleware(reducer, finalState, window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : undefined)

export const initStore = (initialData: Partial<State>, initialEntities: Partial<EntitiesState>) =>
  createStoreWithMiddleware(reducer, createInitialState(initialData, initialEntities))

export const store = isBrowser && initStoreWithFinalState(JSON.parse(window.finalState))
export default store
